import React, { useEffect, useRef, useState } from "react";
import { verifyTicket2 } from "../services/ticket";

const BarcodeScannerBoxGun = ({
  eventId,
  type = "check_in",
  setResult,
  token,
  onLoadingChange,
  resetToken,
  onScanStart,
}) => {
  const inputRef = useRef(null);
  const [scannedCode, setScannedCode] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  const resetScannerInput = () => {
    setScannedCode("");
    if (inputRef.current) {
      inputRef.current.value = "";
      inputRef.current.focus();
    }
  };

  useEffect(() => {
    resetScannerInput();
    const focusInterval = setInterval(() => {
      if (document.activeElement !== inputRef.current) {
        inputRef.current?.focus();
      }
    }, 500);

    return () => clearInterval(focusInterval);
  }, []);

  useEffect(() => {
    resetScannerInput();
  }, [resetToken]);

  const handleClick = () => {
    resetScannerInput();
  };

  const handleKeyDown = async (e) => {
    // Only process when scanner finishes (usually sends Enter)
    if (e.key !== "Enter") return;

    const codeNow = e.currentTarget?.value?.trim() || "";
    console.log("[Scanner] Raw input value:", e.currentTarget?.value);
    console.log("[Scanner] Trimmed submission_id to send:", codeNow);

    if (codeNow && !isProcessing) {
      onScanStart?.();
      setIsProcessing(true);
      onLoadingChange?.(true);

      try {
        const res = await verifyTicket2(codeNow, eventId, type, token);

        console.log("[API] Response:", res?.data);

        // Extract data from the response structure
        if (res.data.success && res.data.data) {
          const ticketData = res.data.data;
          setResult({
            status: "success",
            message: res.data.message,
            first_name: ticketData.first_name,
            last_name: ticketData.last_name,
            profile_url: ticketData.profile_url,
            companyName: ticketData.companyName,
            scanned: ticketData.print_count,
            designation: ticketData.designation,
            event_name: ticketData.event_name,
            ticketClassName: ticketData.ticketClassName,
            ticket_class_name: ticketData.ticket_class_name,
            email: ticketData.email,
            type: type, // Pass the type to know if it's check_in or check_out
            submission_id: ticketData.submission_id,
            print_count: ticketData.print_count,
          });
        } else {
          setResult({
            status: "error",
            message: res.data.message || "Verification failed"
          });
        }
      } catch (error) {
        console.error("API Error:", error);
        setResult({
          status: "error",
          message: error?.response?.data?.message || "Invalid ticket",
        });
      }

      // Clear input and reset processing state after a delay
      resetScannerInput();
      setTimeout(() => {
        setIsProcessing(false);
        onLoadingChange?.(false);
        inputRef.current?.focus();
      }, 300);
    }
  };

  return (
    <div className="flex w-full flex-col items-center">
      <img
        src="https://5.imimg.com/data5/SELLER/Default/2024/8/447050222/HT/PT/SP/2891613/hand-held-bar-code-scanner-500x500.png"
        alt="Scan"
        onClick={handleClick}
        className="mb-2 h-auto w-full max-w-[235px] cursor-pointer object-contain sm:max-w-[320px] lg:max-w-[360px]"
      />
      <input
        ref={inputRef}
        type="text"
        value={scannedCode}
        onChange={(e) => setScannedCode(e.target.value)}
        onKeyDown={handleKeyDown}
        className="absolute opacity-0 pointer-events-none"
        placeholder="Scan barcode here..."
        autoFocus
      />
    </div>
  );
};

export default BarcodeScannerBoxGun;
